import { BaseDto } from "@/shared/dtos/base-dto";

export class periodicidad_plantilla_tarea extends BaseDto {
  public nombre!: string;
}
